export default __webpack_public_path__ + "static/media/city_map.9ac95f43.png";